"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixUnderset = fixUnderset;
const tex_syntax_1 = require("./tex-syntax");
function fixUnderset(tex) {
    return tex.replace(new RegExp(`(\\\\underset${(0, tex_syntax_1.block)(1)})(\\\\redE\\s*${(0, tex_syntax_1.block)(2)})`, "g"), "$1{$2}");
}
